export class GetProfilesForWorkTypeRequest {
    LOB: string = 'OL';
    WorkType: string = '';
    ForceAppt: string = 'N';
    CustomerId: string|number = 0;
    AcvOrgId: string|number = 0;
}
